import {
  BookA,
  Bookmark,
  Contact,
  FolderGit2,
  Images,
  MessageSquareCode,
  Users,
} from "lucide-react";

export function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

export const nonNumericRegex = /^[A-Za-z\s]+$/;

export const sidebarData = [
  {
    id: 1,
    mainTitle: "General",
    menu: [
      {
        id: 1,
        title: "Courses",
        link: "/",
        icon: <BookA />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Testimonials",
        link: "/testimonials",
        icon: <MessageSquareCode />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Gallery",
        link: "/gallery",
        icon: <Images />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Brand",
        link: "/brand",
        icon: <Bookmark />,
        subMenu: [],
      },
    ],
  },
  {
    id: 2,
    mainTitle: "User Management",
    menu: [
      {
        id: 1,
        title: "Users",
        link: "/user",
        icon: <Users />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Contact Us",
        link: "/contact-us",
        icon: <Contact />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Use Case Form",
        link: "/usecase",
        icon: <FolderGit2 />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Event",
        link: "/event",
        icon: <FolderGit2 />,
        subMenu: [],
      },
    ],
  },
];
